const API_URL = "/api/partizi";

export const esalonariApi = {
  // Obține eșalonările
  get: async (partidaId) => {
    const res = await fetch(`${API_URL}/esalonari/${partidaId}`);
    if (!res.ok) throw new Error("Eroare la preluarea eșalonărilor");
    return res.json();
  },

  // Salvează eșalonarea (Luna)
  save: async (datePayload) => {
    const res = await fetch(`${API_URL}/esalonari`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datePayload),
    });
    if (!res.ok) throw new Error("Eroare la salvarea eșalonării");
    return res.json();
  },

  // ȘTERGERE EȘALONARE
  delete: async (id) => {
    const res = await fetch(`${API_URL}/esalonari/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Eroare la ștergerea eșalonării");
    return res.json();
  },

  // SALVEAZA ESALONARILE
  saveRealizari: async (payload) => {
    const res = await fetch(`${API_URL}/salveaza-realizari`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dateRealizari: payload.dateEsalonare,
        partidaId: payload.partidaId,
      }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Eroare la salvarea realizărilor");
    }
    return res.json();
  },

  // Actualizare starea la "reprimit"
  updateStarePartida: async (partidaId, stareNoua) => {
    const res = await fetch(
      `${API_URL}/actualizeaza-stare-partida/${partidaId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stare: stareNoua }),
      },
    );
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Eroare la actualizarea stării");
    }
    return res.json();
  },

  // Ștergere recepție din istoric
  deleteReceptie: async (esalonareId, receptie) => {
    const res = await fetch(`${API_URL}/receptie/${esalonareId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        receptieId: receptie.id,
      }),
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || "Eroare la ștergerea recepției");
    }

    return res.json();
  },
};
